import { render, staticRenderFns } from "./NewBoardIcon.vue?vue&type=template&id=372e6985&scoped=true"
import script from "./NewBoardIcon.vue?vue&type=script&lang=js"
export * from "./NewBoardIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372e6985",
  null
  
)

export default component.exports